import React, { Component } from 'react';
import { Col, Container, Row } from "reactstrap";
import { connect } from "react-redux";
import { Button } from '@material-ui/core';
import Steppers from "../../components/search/Steppers";
import { API_URL } from "../../config/Config";


class Salesinvoice extends Component {

    async handelPrint() {
        window.location.replace(API_URL + 'get-ticket/' + this.props.busissue.BusIssue.ticket_id + '?ticket_type=' + this.props.busissue.BusIssue.ticket_type);
    }

    render() {
        console.log(this.props.busissue.BusIssue);


        return (
            <div className="Ticketreview pt-5 mt-5">
                <Container className="min-height-500">
                    <Row>
                        <Col >
                            <div className="white box search-progress">
                                <Steppers active={5} />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Button className="print-this" onClick={this.handelPrint.bind(this)}>
                                Print Ticket
                            </Button>
                        </Col>

                    </Row>
                    <Row className='Rules-ticket'>
                        <Col>
                            <h4>
                                Attention :
                            </h4>
                        </Col>
                    </Row>
                    <Row className='Rules-ticket-content'>
                        <Col>
                            <p>
                                Lorem ipsum dolor sit amet, sanctus referrentur te nec, recusabo conclusionemque ne nam. Vix te timeam vocibus. Ridens vivendum est ei, eu brute repudiandae mea, mea veniam adipisci reformidans ad. Sea dolorem explicari aliquando cu, tantas ponderum pri ea. Vim an nostro pertinacia comprehensam, per vitae congue ex.

                                Facer hendrerit vis ad. Porro labitur abhorreant mea cu. Has timeam officiis comprehensam ex. Nam eleifend dissentiet et, harum eligendi inciderint te vix. Eum possit eloquentiam cu, pro te illum apeirian hendrerit.

                                Mei laudem commodo id, qui ea atomorum reprehendunt, eam in noster suavitate periculis. No usu suscipit voluptua, has verear epicurei maluisset ad, nam habeo assentior intellegam id. Te sea aperiri corpora copiosae. Cu eros dolorem pro, modo malorum mea eu. Ut has facete utroque recteque.

                                Id consul persius cotidieque cum, recusabo neglegentur nam ei, democritum concludaturque ex has. Soleat dissentiet mei in, eius expetendis pro te. Id quis enim nec, ut etiam periculis voluptaria duo, et summo apeirian mel. Pro expetenda honestatis eu. Eu graeci principes reformidans ius. Audire iisque propriae sed in.

                                Mei ei dicta gubergren voluptatum, nec cu legimus ancillae volutpat. Pri te graece fabulas, in eum illum qualisque. Tota erroribus ut nec. Ex vis erroribus intellegam, bonorum epicurei vituperatoribus cu mea. Ei sea facete salutandi facilisis, per no vitae sadipscing. Quo augue recteque an.
                            </p>
                            <p>
                                Lorem ipsum dolor sit amet, sanctus referrentur te nec, recusabo conclusionemque ne nam. Vix te timeam vocibus. Ridens vivendum est ei, eu brute repudiandae mea, mea veniam adipisci reformidans ad. Sea dolorem explicari aliquando cu, tantas ponderum pri ea. Vim an nostro pertinacia comprehensam, per vitae congue ex.

                                Facer hendrerit vis ad. Porro labitur abhorreant mea cu. Has timeam officiis comprehensam ex. Nam eleifend dissentiet et, harum eligendi inciderint te vix. Eum possit eloquentiam cu, pro te illum apeirian hendrerit.

                                Mei laudem commodo id, qui ea atomorum reprehendunt, eam in noster suavitate periculis. No usu suscipit voluptua, has verear epicurei maluisset ad, nam habeo assentior intellegam id. Te sea aperiri corpora copiosae. Cu eros dolorem pro, modo malorum mea eu. Ut has facete utroque recteque.

                                Id consul persius cotidieque cum, recusabo neglegentur nam ei, democritum concludaturque ex has. Soleat dissentiet mei in, eius expetendis pro te. Id quis enim nec, ut etiam periculis voluptaria duo, et summo apeirian mel. Pro expetenda honestatis eu. Eu graeci principes reformidans ius. Audire iisque propriae sed in.

                                Mei ei dicta gubergren voluptatum, nec cu legimus ancillae volutpat. Pri te graece fabulas, in eum illum qualisque. Tota erroribus ut nec. Ex vis erroribus intellegam, bonorum epicurei vituperatoribus cu mea. Ei sea facete salutandi facilisis, per no vitae sadipscing. Quo augue recteque an.
                            </p>
                            <p>
                                Lorem ipsum dolor sit amet, sanctus referrentur te nec, recusabo conclusionemque ne nam. Vix te timeam vocibus. Ridens vivendum est ei, eu brute repudiandae mea, mea veniam adipisci reformidans ad. Sea dolorem explicari aliquando cu, tantas ponderum pri ea. Vim an nostro pertinacia comprehensam, per vitae congue ex.

                                Facer hendrerit vis ad. Porro labitur abhorreant mea cu. Has timeam officiis comprehensam ex. Nam eleifend dissentiet et, harum eligendi inciderint te vix. Eum possit eloquentiam cu, pro te illum apeirian hendrerit.

                                Mei laudem commodo id, qui ea atomorum reprehendunt, eam in noster suavitate periculis. No usu suscipit voluptua, has verear epicurei maluisset ad, nam habeo assentior intellegam id. Te sea aperiri corpora copiosae. Cu eros dolorem pro, modo malorum mea eu. Ut has facete utroque recteque.

                                Id consul persius cotidieque cum, recusabo neglegentur nam ei, democritum concludaturque ex has. Soleat dissentiet mei in, eius expetendis pro te. Id quis enim nec, ut etiam periculis voluptaria duo, et summo apeirian mel. Pro expetenda honestatis eu. Eu graeci principes reformidans ius. Audire iisque propriae sed in.

                                Mei ei dicta gubergren voluptatum, nec cu legimus ancillae volutpat. Pri te graece fabulas, in eum illum qualisque. Tota erroribus ut nec. Ex vis erroribus intellegam, bonorum epicurei vituperatoribus cu mea. Ei sea facete salutandi facilisis, per no vitae sadipscing. Quo augue recteque an.
                            </p>
                            <p>
                                Lorem ipsum dolor sit amet, sanctus referrentur te nec, recusabo conclusionemque ne nam. Vix te timeam vocibus. Ridens vivendum est ei, eu brute repudiandae mea, mea veniam adipisci reformidans ad. Sea dolorem explicari aliquando cu, tantas ponderum pri ea. Vim an nostro pertinacia comprehensam, per vitae congue ex.

                                Facer hendrerit vis ad. Porro labitur abhorreant mea cu. Has timeam officiis comprehensam ex. Nam eleifend dissentiet et, harum eligendi inciderint te vix. Eum possit eloquentiam cu, pro te illum apeirian hendrerit.

                                Mei laudem commodo id, qui ea atomorum reprehendunt, eam in noster suavitate periculis. No usu suscipit voluptua, has verear epicurei maluisset ad, nam habeo assentior intellegam id. Te sea aperiri corpora copiosae. Cu eros dolorem pro, modo malorum mea eu. Ut has facete utroque recteque.

                                Id consul persius cotidieque cum, recusabo neglegentur nam ei, democritum concludaturque ex has. Soleat dissentiet mei in, eius expetendis pro te. Id quis enim nec, ut etiam periculis voluptaria duo, et summo apeirian mel. Pro expetenda honestatis eu. Eu graeci principes reformidans ius. Audire iisque propriae sed in.

                                Mei ei dicta gubergren voluptatum, nec cu legimus ancillae volutpat. Pri te graece fabulas, in eum illum qualisque. Tota erroribus ut nec. Ex vis erroribus intellegam, bonorum epicurei vituperatoribus cu mea. Ei sea facete salutandi facilisis, per no vitae sadipscing. Quo augue recteque an.
                            </p>
                        </Col>
                    </Row>

                </Container>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        busissue: state.busissue
    }
};

export default connect(mapStateToProps)(Salesinvoice)



// WEBPACK FOOTER //
// ./src/containers/search/Salesinvoice.jsx